import 'Onboarding/angularModule';
import angularDirectiveToReact from 'Angular2reactHelper';
import { useAngularToReactRoute } from 'Angular2reactHelper/useAngularToReactRoute';

const OnboardingHybridForgotPasswordDirective = angularDirectiveToReact('onboardingHybridForgotPassword', {});

export function OnboardingHybridForgotPasswordComponent() {
    const [key] = useAngularToReactRoute();
    return <OnboardingHybridForgotPasswordDirective key={key} />;
}
